import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionButtonComponent } from '../action-button/action-button.component';

@Component({
  selector: 'app-dashboard-metric-card',
  standalone: true,
  imports: [CommonModule, ActionButtonComponent],
  templateUrl: './dashboard-metric-card.component.html',
  styleUrls: ['./dashboard-metric-card.component.css'],
})
export class DashboardMetricCardComponent {
  @Input() titleCard: string = '';
  @Input() value: string | number = '';
  @Input() description: string = '';
  @Input() type: 'primary' | 'warning' | 'danger' = 'primary';
  @Input() buttonLabel: string = '';
  @Input() buttonRoute: string = '';
  @Input() isLoading: boolean = false;
  @Input() useConditionalColor: boolean = false; // Controla se deve aplicar cor condicional ao valor

  get valueColorClass(): string {
    // Se não deve usar cor condicional, retorna a cor baseada no type
    if (!this.useConditionalColor) {
      switch (this.type) {
        case 'primary':
          return 'text-primary';
        case 'warning':
          return 'text-warning';
        case 'danger':
          return 'text-danger';
        default:
          return 'text-primary';
      }
    }

    // Se deve usar cor condicional, aplica a lógica de 0 = primary, > 0 = danger
    const numValue =
      typeof this.value === 'string'
        ? Number.parseInt(this.value, 10)
        : this.value;

    return numValue === 0 ? 'text-primary' : 'text-danger';
  }

  get buttonVariant():
    | 'outline-primary'
    | 'outline-warning'
    | 'outline-danger' {
    switch (this.type) {
      case 'primary':
        return 'outline-primary';
      case 'warning':
        return 'outline-warning';
      case 'danger':
        return 'outline-danger';
      default:
        return 'outline-primary';
    }
  }
}
